export const removeEmptyValuePair = (target: any) => {
  for (const [key, index] of Object.entries(target)) {
    if (index === '' || index === null || index === undefined) {
      delete target[key];
    }
  }
  return target;
};
